<template>
    <div class="layui-fluid">
    <div class="layui-row layui-col-space15">
      <div class="layui-col-md12">
        <div class="layui-card">
          <div class="layui-card-header">设置我的资料</div>
          <div class="layui-card-body" pad15="">
            
            <div class="layui-form" lay-filter="">
              <div class="layui-form-item">
                <label class="layui-form-label">登录名</label>
                <div class="layui-input-inline">
                  <input type="text" name="" value="" v-model="userInfo.ACCOUNT" readonly="true" class="layui-input">
                </div>
                <div class="layui-form-mid layui-word-aux">登录名不可修改</div>
              </div>
              <div class="layui-form-item">
                <label class="layui-form-label">用户名</label>
                <div class="layui-input-inline">
                  <input type="text" name="" value=""  v-model="userInfo.USERNAME" autocomplete="off" placeholder="请输入昵称" class="layui-input">
                </div>
              </div>
              <div class="layui-form-item">
                <label class="layui-form-label">性别</label>
                <div class="layui-input-inline">
                  <div class="layui-input-inline">
                        <layui-radio v-model="userInfo.SEX">
                            <input type="radio"  value="man" title="男" />
                            <input type="radio"  value="women" title="女"/>
                        </layui-radio>
                    </div>
                </div>
              </div>
              <div class="layui-form-item">
                <label class="layui-form-label">联系方式</label>
                <div class="layui-input-inline" >
                  <input type="text" name="" v-model="userInfo.TEL" autocomplete="off" class="layui-input">
                </div>
              </div>
              <div class="layui-form-item">
                <label class="layui-form-label">邮箱</label>
                <div class="layui-input-inline" >
                  <input type="text" name="" v-model="userInfo.EMAIL" autocomplete="off" class="layui-input">
                </div>
              </div>
             <div class="layui-form-item">
                <label class="layui-form-label">生日</label>
                <div class="layui-input-inline">
                    <layui-datetime placeholder="请输入生日" v-model="userInfo.BIRTHDAY"></layui-datetime>
                </div>
             </div>
              <div class="layui-form-item">
                <div class="layui-input-block">
                  <button class="layui-btn" @click="saveUserInfo()">确认修改</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'UserChangeInfo',
  data () {
    return {
        userInfo: {
            IS_NEW: false,
            USERID: null,
            ACCOUNT: null,
            USERNAME: null,
            SEX: null,
            TEL: null,
            EMAIL: null,
            BIRTHDAY: null,
        },
        requestUniqueId: 'getUserInfo'
    }
  },
  mounted() {
      var user = this.security.getUser();
      this.userInfo.USERID = user.getUid();
      let p2 = {USERID: this.userInfo.USERID};
      this.api.queryList('DB_USER', {p2 : p2} , this.requestUniqueId).then((response)=> {
        var result = response.result[0];
        this.userInfo.ACCOUNT  = result.ACCOUNT;
        this.userInfo.USERNAME = result.USERNAME;
        this.userInfo.SEX = result.SEX;
        this.userInfo.TEL = result.TEL;
        this.userInfo.EMAIL = result.EMAIL;
        this.userInfo.BIRTHDAY = result.BIRTHDAY;
      });
  },
  methods: {
    saveUserInfo() {
		this.layer.openConfirm('确定要修改用户信息吗?', ()=> {
			this.api.save('DB_USER', this.userInfo, this.requestUniqueId).then(response => {
				if(response.errorMsg) {
					this.layer.openAlert(response.errorMsg, false);
				} else {
					this.layer.openSuccess('修改成功!');
					var user = this.security.getUser();
					user.setUname(this.userInfo.USERNAME);
					this.security.updateUser(user);
					this.$bus.$emit(this.dict.event.UPDATE_USERINFO);
				}
			});
		});  
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/ywpt/user/UserChangeInfo.vue